import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventDetails: {},
};
const eventDetailsSlice = createSlice({
  name: "evnetDetails",
  initialState,
  reducers: {
    setSidebarDetails: (state, action) => {
      state.eventDetails = action.payload.eventDetails;
    },
  },
});

export const { setSidebarDetails } = eventDetailsSlice.actions;
export default eventDetailsSlice;
